import { render } from "./NumberOptionField.vue?vue&type=template&id=cf512606&scoped=true"
import script from "./NumberOptionField.vue?vue&type=script&lang=js"
export * from "./NumberOptionField.vue?vue&type=script&lang=js"

import "./NumberOptionField.vue?vue&type=style&index=0&id=cf512606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf512606"]])

export default __exports__